import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Dashboard from '@/components/Dashboard'
import editEmployee from '@/components/editEmployee'
import newEmployee from '@/components/new_employee'
import viewEmployee from '@/components/vueEmployee'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/new',
      name: 'new-employee',
      component: newEmployee
    },
    {
      path: '/edit/:employee_id',
      name: 'edit-employee',
      component: editEmployee
    },
    {
      path: '/:employee_id',
      name: 'view-employee',
      component: viewEmployee
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js